/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { ReactElement } from 'react';
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';

export interface CollapseGroupProps {
  title: string | JSX.Element;
  open: boolean;
  children: JSX.Element | JSX.Element[];
  collapseButtonClicked: (event: React.MouseEvent) => void;
}

const CollapseGroupHeader = styled.div`
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  letter-spacing: 0px;
  line-height: 20px;
  font-size: 16px;
  color: white;
  font-weight: normal;
  position: relative;
  height: 20px;
`;
const CollapseGroupLabelsContainer = styled.div`
  padding-top: 20px;
  padding-left: 40px;
  box-sizing: border-box;
`;
const CollapseGroupPanel = styled.div`
  padding-bottom: 20px;
  box-sizing: border-box;
`;

const UncollapsedIcon = styled(KeyboardArrowRight)`
  color: white;
  margin-top: -10px;
  height: 24px;
  cursor: pointer;
  left: 16px;
  position: absolute;
  top: 8px;
`;
const CollapsedIcon = styled(KeyboardArrowDown)`
  color: white;
  margin-top: -10px;
  height: 24px;
  cursor: pointer;
  left: 16px;
  position: absolute;
  top: 7px;
`;
const CollapseGroupHeaderCollapseText = styled.span`
  position: absolute;
  cursor: pointer;
  left: 40px;
  letter-spacing: 0px;
  line-height: 20px;
  font-weight: normal;
`;
const CollapseGroup = (props: CollapseGroupProps): ReactElement => {
  const { title, children, open, collapseButtonClicked } = props;
  return (
    <CollapseGroupPanel>
      <CollapseGroupHeader>
        {open ? (
          <CollapsedIcon className="details__panel__collapsed__icon" onClick={collapseButtonClicked} />
        ) : (
          <UncollapsedIcon className="details__panel__collapsed__icon" onClick={collapseButtonClicked} />
        )}
        <CollapseGroupHeaderCollapseText
          data-test="terminal_details__collapse_group__header"
          onClick={collapseButtonClicked}
        >
          {title}
        </CollapseGroupHeaderCollapseText>
      </CollapseGroupHeader>
      <CollapseGroupLabelsContainer className="details__panel__collapse__container">
        {open ? children : null}
      </CollapseGroupLabelsContainer>
    </CollapseGroupPanel>
  );
};
export default CollapseGroup;
